export default (lang) => {
  return (dispatch) => {
    dispatch({
      type: "LANG",
      lang,
    })
  }
}
